import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { API, formatApiErrorDetail } from "@/auth";

export default function HomepageDateCard() {
  const [override, setOverride] = useState("");
  const [autoToday, setAutoToday] = useState("");
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = () =>
    axios
      .get(`${API}/admin/site/date`, { withCredentials: true })
      .then((r) => { setOverride(r.data.display_date || ""); setAutoToday(r.data.auto_today || ""); })
      .catch(() => {})
      .finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/admin/site/date`, { display_date: override }, { withCredentials: true });
      toast.success(override ? "Homepage date set" : "Set to automatic (today)");
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setSaving(false); }
  };

  const clearOverride = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/site/date`, { display_date: "" }, { withCredentials: true });
      setOverride("");
      toast.success("Homepage date set to automatic");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setSaving(false); }
  };

  if (loading) return null;

  return (
    <div className="ap-card" data-testid="homepage-date-card">
      <h2 className="ap-card-title">HOMEPAGE DATE</h2>
      <form onSubmit={save} className="ap-form">
        <p style={{ margin: 0, color: "#64748b", fontSize: 13 }}>
          The homepage shows today's date automatically (currently <b>{autoToday}</b> — updates after 12:00 AM IST).
          Set a specific date below to override, or leave blank for automatic.
        </p>
        <label className="ap-field">
          <span>Manual date override:</span>
          <Input
            data-testid="homepage-date-input"
            type="date"
            value={override}
            onChange={(e) => setOverride(e.target.value)}
          />
        </label>
        <div className="ap-form-inline">
          <button className="ap-btn ap-btn-primary" data-testid="homepage-date-save" type="submit" disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
          {override && (
            <button type="button" className="ap-btn ap-btn-secondary" data-testid="homepage-date-clear" onClick={clearOverride} disabled={saving}>
              Reset to automatic
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
